import { type Dispatch, useMemo } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import type { ZodType } from 'zod'

export const useStateWithLocalStorage = <T>(
  key: string,
  defaultValue: T,
  schema: ZodType<T>,
): [T, Dispatch<T>, () => void] => {
  const [rawValue, setRawValue, remove] = useLocalStorage(key, defaultValue)

  const value = useMemo(() => {
    const result = schema.safeParse(rawValue)
    return result.success ? result.data : defaultValue
  }, [rawValue, schema, defaultValue])

  return [value, setRawValue, remove] as const
}
